import mixins from 'vue-typed-mixins';

import StudyMixin, { STUDY_RESULT } from '@/user/mixins/StudyMixin';


export default mixins(StudyMixin).extend({

  name: 'StudyResultDialog',

  computed: {
    visible(): boolean {
      return this.studyResult !== null;
    },
    resultIcon(): string | null {
      switch (this.studyResult) {
        case STUDY_RESULT.SCORE_EMPTY:
        case STUDY_RESULT.SCORE_RETRY:
        case STUDY_RESULT.SCORE_FAIL:
        case STUDY_RESULT.UNIT_TIMEUP:
          return 'times';
        case STUDY_RESULT.SCORE_SUCCESS:
          return 'check';
        default:
          return null;
      }
    },
    textHtml(): string {
      switch (this.studyResult) {
        case STUDY_RESULT.SCORE_EMPTY:     return '<ruby>空欄<rt>くうらん</rt></ruby>があるよ';
        case STUDY_RESULT.SCORE_SUCCESS:   return '<ruby>正解<rt>せいかい</rt></ruby>';
        case STUDY_RESULT.SCORE_RETRY:     return 'もう<ruby>一度<rt>いちど</rt></ruby>チャレンジ';
        case STUDY_RESULT.SCORE_FAIL:      return '<ruby>不正解<rt>ふせいかい</rt></ruby>';
        case STUDY_RESULT.UNIT_SUCCESS:    return 'ステージクリア';
        case STUDY_RESULT.UNIT_FAIL:       return '<ruby>残念<rt>ざんねん</rt></ruby>';
        case STUDY_RESULT.UNIT_TIMEUP:     return '<ruby>時間切<rt>じかんぎ</rt></ruby>れ';
        case STUDY_RESULT.COURSE_COMPLETE: return '<ruby>全<rt>ぜん</rt></ruby>ステージクリア';
        default:                           return '';
      }
    },
    visibleToMenu(): boolean {
      switch (this.studyResult) {
        case STUDY_RESULT.UNIT_SUCCESS:
        case STUDY_RESULT.UNIT_FAIL:
        case STUDY_RESULT.COURSE_COMPLETE:
          return true;
        default:
          return false;
      }
    },
  },

  methods: {
    afterScore(): void {
      this.$emit('afterScore');
    },
    toMenu(): void {
      if (!this.visibleToMenu) return;

      this.$emit('toMenu');
    }
  },

});
